import { Component, inject } from '@angular/core';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { ORG_ADMIN_ORG_KEY } from '@processpuzzle/org-admin';

/**
 * What a member without `org-admin` sees under `/<orgKey>/admin`, in place of the users and the roles.
 *
 * Says who may administer and whom to ask, and offers nothing else: the screens behind it would only
 * show the backend's refusal as empty lists. See `orgAdminGuard`.
 */
@Component({
  selector: 'app-administration-denied',
  imports: [MatCard, MatCardTitle, MatCardContent, MatIcon, TranslocoDirective],
  template: `
    <ng-container *transloco="let t; prefix: 'administrationDenied'">
      <mat-card class="administration-denied-card" test-id="administration-denied">
        <mat-card-title>
          <mat-icon>lock</mat-icon>
          {{ t('title') }}
        </mat-card-title>
        <mat-card-content>
          <p>{{ t('text', { orgKey: orgKey }) }}</p>
          <p class="hint">{{ t('hint') }}</p>
        </mat-card-content>
      </mat-card>
    </ng-container>
  `,
  styles: [
    `
      .administration-denied-card {
        max-width: 640px;
        margin: 32px auto;
      }

      .hint {
        font-size: 0.9rem;
        opacity: 0.8;
      }
    `,
  ],
})
export class AdministrationDeniedComponent {
  readonly orgKey = inject(ORG_ADMIN_ORG_KEY);
}
